import { initReactQueryAuth } from 'react-query-auth';
import appLoading from '@/assets/animation/loading.json';
import { APP_PATH } from '@/config';
import {
  getUser,
  UserResponse,
  LoginCredentialsDTO,
  AuthUser,
  RegisterCredentialsDTO,
  loginWithEmail,
} from '@/features/auth';
import storage from '@/utils/storage';
import Lottie from 'lottie-react';
async function handleUserResponse(data: UserResponse) {
  if (data.token) {
    storage.setToken(`Bearer ${data.token}`);
  }

  return data;
}

async function loadUser() {
  if (storage.getToken()) {
    const data = await getUser();
    return data;
  }
  return null;
}

async function loginFn(data: LoginCredentialsDTO) {
  let response;
  if (data.userData) {
    response = data.userData;
  } else {
    response = await loginWithEmail(data);
  }

  const user = await handleUserResponse(response);

  return user;
}

async function registerFn(data: RegisterCredentialsDTO) {
  return null;
}


async function logoutFn() {
  storage.clearToken();
 window.location.assign((window.location.origin + APP_PATH) as unknown as string);
}

const authConfig = {
  loadUser,
  loginFn,
  registerFn,
  logoutFn,
  LoaderComponent() {
    return (
      <div className="w-screen h-screen flex justify-center items-center">
        <Lottie className="loading-loader-class" animationData={appLoading} />
      </div>
    );
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth<
  AuthUser | null,
  unknown,
  LoginCredentialsDTO,
  RegisterCredentialsDTO
>(authConfig);
